export default "__VITE_ASSET__BqsvtX8t__"